import request from '@/utils/request'
import qs from 'qs'

export function initData(url, params) {
  return request({
    url: url + '?' + qs.stringify(params, { indices: false }),
    method: 'get'
  })
}

export function download(url, params) {
  console.info("params=",params)
  return request({
    url: url + '?' + qs.stringify(params, { indices: false }),
    method: 'get',
    responseType: 'blob'
  })
}

export function downloadPost(url, data) {
  return request({
    url: url,
    data: data,
    method: 'post',
    responseType: 'blob'
  })
}

export function edit(url, id) {
  return request({
    url: url + id,
    method: 'get'
  })
}
